<template>
  <section class="section section-observed content-detail-page">
    <ContentDetailPanel v-if="front.selectedContent" />
    <article v-else-if="front.contentDetailLoading" class="content-detail-loading">
      <p class="section-kicker">内容详情</p>
      <h2>正在加载内容...</h2>
    </article>
    <article v-else class="empty-state">
      <p class="section-kicker">内容详情</p>
      <h2>{{ front.contentDetailError || '未找到该内容' }}</h2>
      <button type="button" class="ghost-action compact" @click="front.goPath('/')">返回首页</button>
    </article>
  </section>
</template>

<script>
import ContentDetailPanel from '../../components/news/ContentDetailPanel.vue'

export default {
  name: 'ContentDetailPage',
  components: { ContentDetailPanel },
  inject: ['front']
}
</script>

<style scoped>
.content-detail-page {
  max-width: var(--content-max);
  padding-top: 28px;
  padding-bottom: 48px;
}

.content-detail-loading,
.empty-state {
  padding: 40px 36px;
  border: 1px solid var(--border);
  border-top: 3px solid var(--gold);
  border-radius: var(--front-radius);
  background: #fff;
  box-shadow: var(--shadow-soft);
}
</style>
